import EventsManager from 'managers/events.manager';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';

if (!__DEV__) {
  EventsManager.on(
    'PLAY',
    () => OfflinePluginRuntime.install({
      onUpdateReady: () => OfflinePluginRuntime.applyUpdate(),
    }),
  );
}
